<div id="staff-tools" class="d-flex flex-column" *ngIf="whiteboard.container">
  <div class="d-flex flex-wrap align-items-center justify-content-end" style="margin-bottom: 3px">
    <div class="d-flex flex-wrap align-items-center mr-auto"
         [class.disabled]="localUser.currentSelectedTab !== ViewportTab.WHITEBOARD && !classroom.showPrivateWhiteboard || isInRestrictedMode">
      <button class="btn whiteboard-btn p-0" id="wb_btn_undo"
              [disabled]="whiteboard | isShared"
              (mousedown)="undo()" title="Undo">
        <img class="no-drag" src="assets/img/whiteboard/arrow-left-rotate.svg" height="17" alt="">
      </button>
      <button class="btn whiteboard-btn p-0 mr-0" id="wb_btn_redo"
              [disabled]="whiteboard | isShared"
              (mousedown)="redo()" title="Redo">
        <img class="no-drag" src="assets/img/whiteboard/arrow-rotate-forward.svg" height="17" alt="">
      </button>

      <div class="separator mx-1"></div>

      <button class="btn whiteboard-btn p-0" id="wb_btn_highlighter"
              [class.active]="isHighlightToolOn"
              (mousedown)="highlighter()" title="Highlighter">
        <img class="no-drag" src="assets/img/whiteboard/highlighter.svg" height="17" alt="">
      </button>
      <button class="btn whiteboard-btn p-0 mr-0" id="wb_btn_pointer"
              [class.active]="isPointerToolOn"
              (mousedown)="pointer()" title="Pointer">
        <img class="no-drag" src="assets/img/whiteboard/pointer-icon.svg" height="24" alt="">
      </button>

      <div class="separator mx-1"></div>

      <button class="btn whiteboard-btn p-0 mr-1" id="wb_btn_select"
              [class.active]="isSelectToolOn"
              (mousedown)="select()" title="Select">
        <img class="no-drag" src="assets/img/whiteboard/select.svg" height="24" alt="">
      </button>

      <button class="btn whiteboard-btn p-0 mr-0" id="wb_btn_eraser"
              [class.active]="isEraserToolOn"
              (mousedown)="eraser()" title="Eraser">
        <img class="no-drag" src="assets/img/whiteboard/eraser-tool.svg" height="24" alt="">
      </button>

      <div class="separator mx-1"></div>

      <div ngbDropdown autoClose="{{'outside'}}" class="select-shape-colors">
        <div style="position:absolute; background: url('assets/img/whiteboard/none_30x30.png') no-repeat !important; width: 100%; height: 100%"></div>

        <button ngbDropdownToggle type="button" id="wb_btn_shape_style" class="btn whiteboard-btn p-0 without-dropdown-arrow transparent-bg"
                title="Shape Properties"
                [class.background-none]="isTransparent(isFillToolOn ? wbFillToolColor : wbStyle.fillColor)"
                [style]="{'background-color': isFillToolOn ? wbFillToolColor : wbStyle.fillColor, 'border': getStrokeStyle()}">

          <img *ngIf="isFillToolOn" class="no-drag" src="assets/img/whiteboard/fill.svg" height="17" alt="">
        </button>
        <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu dropdown-content">
          <div class="font-size-12 mb-1">Stroke</div>
          <div class="stroke-grid mb-2">
              <div class="btn stroke-item"
                   *ngFor="let stroke of strokesList"
                   [class.active]="getWBStyleStrokeWidth() === stroke.toString()"
                   (mousedown)="setWBStyleStrokeWidth(stroke)">
                <svg class="stroke-width-button" width="24" height="24" viewBox="0 0 24 24">
                  <path stroke="#000" [attr.stroke-width]="mkPx(stroke)" stroke-linecap="round" d="M 5,17 17,5"/>
                </svg>
              </div>
            <div class="dropdown">
              <button type="button" class="btn stroke-item p-0 without-dropdown-arrow"
                      style="background: #e7eaef; border: 1px solid #cecece;"
                      (click)="toggleStrokeDropdown($event)">
                <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu shadow cs-dropdown-menu"
                   [class.show]="isDialogOpen.strokesMore" style="min-width: 32px">
                <button class="dropdown-item btn d-flex align-items-center px-2"
                        *ngFor="let strokesMore of strokesMoreList"
                        [class.active]="getWBStyleStrokeWidth() === strokesMore.toString()"
                        (mousedown)="setWBStyleStrokeWidth(strokesMore)" >
                  {{strokesMore}}
                </button>
              </div>
            </div>
          </div>
          <div class="dropdown mb-3">
            <button type="button" class="btn p-0 without-dropdown-arrow rounded-0 w-100"
                    style="background: #e7eaef; border: 1px solid #cecece;" title=""
                    (click)="toggleDashStylesDropdown($event)">
              <svg class="stroke-width-button" viewBox="0 0 134 22" width="100%" height="22">
                <path stroke="#000" stroke-width="2px" [attr.stroke-dasharray]="getWBDashArray()" stroke-linecap="round" d="M 5,11 130,11"/>
              </svg>
            </button>
            <div class="dropdown-menu shadow cs-dropdown-menu px-1 dash-style-list-dropdown w-100 m-0"
                 [class.show]="isDialogOpen.dashStyles">
              <div class="btn dash-item dropdown-item p-0 d-block rounded-0"
                   *ngFor=" let dashStyle of dashStylesList"
                   [class.active]="getWBDashArray() === dashStyle"
                   (mousedown)="setWBDashArray(dashStyle)">
                <svg class="stroke-width-button" viewBox="0 0 134 22" width="100%" height="22">
                  <path stroke="#000" stroke-width="2px" [attr.stroke-dasharray]="dashStyle" stroke-linecap="round" d="M 5,11 130,11"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="colors-grid mb-3">
            <div class="btn color-item transparent"
                 [class.active]="isTransparent(wbStyle.strokeColor)"
                 (mousedown)="setWBStrokeColor('none'); setColorPickerValue('cpStroke', '#00000000')"></div>
            <div class="btn color-item"
                 *ngFor="let color of colorsList"
                 [style]="{'background': color, 'border': color === '#ffffff' ? '1px solid #cecece' : 'none'}"
                 [class.active]="areSameColors(wbStyle.strokeColor, color)"
                 (mousedown)="setColorPickerValue('cpStroke', color)"></div>
            <app-custom-color-picker #colorPicker
                                     [id]="'cpStroke'"
                                     (visibilityChange)="colorPickerVisibilityChange($event)"
                                     (colorChange)="setWBStrokeColor($event)">
            </app-custom-color-picker>
          </div>

          <hr>

          <div class="font-size-12 mb-1">Fill Object</div>
          <div class="colors-grid">
            <div class="btn color-item transparent"
                 [class.active]="isTransparent(wbStyle.fillColor)"
                 (mousedown)="setWBFillColor('none'); setColorPickerValue('cpFill', '#00000000')">
            </div>
            <div class="btn color-item"
                 *ngFor="let color of colorsList"
                 [style]="{'background-color': color, 'border': color === '#ffffff' ? '1px solid #cecece' : 'none'}"
                 [class.active]="areSameColors(wbStyle.fillColor, color)"
                 (mousedown)="setColorPickerValue('cpFill', color)"></div>
            <!--suppress JSUnusedGlobalSymbols -->
            <app-custom-color-picker #colorPicker
                                     [id]="'cpFill'"
                                     (visibilityChange)="colorPickerVisibilityChange($event)"
                                     (colorChange)="setWBFillColor($event)">
            </app-custom-color-picker>
          </div>
          <hr>

          <div class="fill-area">
            <div class="font-size-12 mb-1" style="justify-content: space-between; display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center">
              <span class="mr-1"> Fill enclosed area </span>
              <span class="fill-info" title="Filling is applied only within enclosed areas.">
                <i class="fa-regular fa-circle-info"></i>
              </span>
            </div>

            <div class="colors-grid">
              <button class="btn whiteboard-btn p-0 mr-0" title="Fill enclosed area" style="min-width: 24px; width: 24px; height: 24px;"
                      [class.active]="isFillToolOn"
                      (mousedown)="fill()">
                <i class="no-drag fa-solid fa-fill-drip"></i>
              </button>
              <div class="btn color-item"
                   *ngFor="let color of colorsList"
                   [style]="{'background-color': color, 'border': color === '#ffffff' ? '1px solid #cecece' : 'none'}"
                   [class.active]="areSameColors(wbFillToolColor, color)"
                   (mousedown)="setColorPickerValue('cpFillToolColor', color)"></div>
              <!--suppress JSUnusedGlobalSymbols -->
              <app-custom-color-picker #colorPicker
                                       [id]="'cpFillToolColor'"
                                       [openTo]="'up'"
                                       (visibilityChange)="colorPickerVisibilityChange($event)"
                                       (colorChange)="setWBFillToolColor($event)">
              </app-custom-color-picker>
            </div>
          </div>

        </div>
      </div>

      <button class="btn whiteboard-btn p-0"
              [class.active]="isFreeToolOn"
              id="wb_btn_pen" (mousedown)="free()" title="Pen">
        <img class="no-drag" src="assets/img/whiteboard/pencil.svg" height="24" alt="">
      </button>

      <div ngbDropdown class="btn-group">
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_line" title="Line"
                [class.d-none]="activeDrawer.linear !== wbContainer.drawers.line"
                [class.active]="isLineToolOn"
                (mousedown)="line()">
          <img class="no-drag" src="assets/img/whiteboard/draw-line.svg" height="17" alt="Draw line">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_polyline" title="Polyline"
                [class.d-none]="activeDrawer.linear !== wbContainer.drawers.polyline"
                [class.active]="isPolylineToolOn"
                (mousedown)="polyline()">
          <img class="no-drag" src="assets/img/whiteboard/polyline.svg" height="17" alt="Draw polyline">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_polygon" title="Polygon"
                [class.d-none]="activeDrawer.linear !== wbContainer.drawers.polygon"
                [class.active]="isPolygonToolOn"
                (mousedown)="polygon()">
          <img class="no-drag" src="assets/img/whiteboard/polygon.svg" height="17" alt="Draw polygon">
        </button>
        <button ngbDropdownToggle type="button" id="wb_btn_lines_dd" class="btn whiteboard-btn dropdown-toggle-arrow-btn px-1">
          <span class="caret"></span>
        </button>
        <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu">
          <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="line()" title="Line">
            <img src="assets/img/whiteboard/draw-line.svg" height="17" class="no-drag mr-2" alt=""> Line
          </button>
          <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="polyline() " title="Polyline">
            <img src="assets/img/whiteboard/polyline.svg" height="17" class="no-drag mr-2" alt=""> Polyline
          </button>
          <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="polygon()" title="Polygon">
            <img src="assets/img/whiteboard/polygon.svg" height="17" class="no-drag mr-2" alt=""> Polygon
          </button>
        </div>
      </div>

      <div ngbDropdown class="btn-group select-shape">
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_circle" title="Circle"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.circle"
                [class.active]="isCircleToolOn"
                (mousedown)="circle()">
          <img class="no-drag" src="assets/img/whiteboard/draw-circle.svg" height="18" alt="Draw circle">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_ellipse" title="Ellipse"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.ellipse"
                [class.active]="isEllipseToolOn"
                (mousedown)="ellipse()">
          <img class="no-drag" src="assets/img/whiteboard/draw-ellipse.svg" height="18" alt="Draw ellipse">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_rectangle" title="Rectangle"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.rectangle"
                [class.active]="isRectangleToolOn"
                (mousedown)="rectangle()">
          <img class="no-drag" src="assets/img/whiteboard/draw-rectangle.svg" height="18" alt="Draw rectangle">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_parallelogram" title="Parallelogram"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.parallelogram"
                [class.active]="isParallelogramToolOn"
                (click)="parallelogram()">
          <img class="no-drag" src="assets/img/whiteboard/draw-parallelogram.svg" height="18" alt="Draw parallelogram">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_isosceles_trapezoid" title="Isosceles Trapezoid"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.isoscelesTrapezoid"
                [class.active]="isIsoscelesTrapezoidToolOn"
                (click)="isoscelesTrapezoid()">
          <img class="no-drag" src="assets/img/whiteboard/draw-isosceles-trapezoid.svg" height="18" alt="Draw isosceles trapezoid">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_triangle" title="Isosceles triangle"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.isoscelesTriangle"
                [class.active]="isIsoscelesTriangleToolOn"
                (mousedown)="triangle()">
          <img class="no-drag" src="assets/img/whiteboard/draw-triangle.svg" height="18" alt="Draw triangle">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_right_triangle" title="Right Triangle"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.rightTriangle"
                [class.active]="isRightTriangleToolOn"
                (mousedown)="rightTriangle()">
          <img class="no-drag" src="assets/img/whiteboard/draw-right-triangle.svg" height="18" alt="Draw right triangle">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_cube" title="Cube"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.cube"
                [class.active]="isCubeToolOn"
                (mousedown)="cube()">
          <img class="no-drag" src="assets/img/whiteboard/draw-cube.svg" height="18" alt="Draw Cube">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_pyramid" title="Pyramid"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.pyramid"
                [class.active]="isPyramidToolOn"
                (mousedown)="pyramid()">
          <img class="no-drag" src="assets/img/whiteboard/draw-pyramid.svg" height="18" alt="Draw Pyramid">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_prism" title="Right Prism"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.prism"
                [class.active]="isPrismToolOn"
                (mousedown)="prism()">
          <img class="no-drag" src="assets/img/whiteboard/draw-prism.svg" height="18" alt="Draw Right Prism">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_cylinder" title="Cylinder"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.cylinder"
                [class.active]="isCylinderToolOn"
                (mousedown)="cylinder()">
          <img class="no-drag" src="assets/img/whiteboard/draw-cylinder.svg" height="18" alt="Draw Cylinder">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_cone" title="Cone"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.cone"
                [class.active]="isConeToolOn"
                (mousedown)="cone()">
          <img class="no-drag" src="assets/img/whiteboard/draw-cone.svg" height="18" alt="Draw Cone">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_sphere" title="Sphere"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.sphere"
                [class.active]="isSphereToolOn"
                (mousedown)="sphere()">
          <img class="no-drag" src="assets/img/whiteboard/draw-sphere.svg" height="18" alt="Draw Sphere">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_parabola" title="Parabola"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.parabola"
                [class.active]="isParabolaToolOn"
                (mousedown)="parabola()">
          <img class="no-drag" src="assets/img/whiteboard/parabola.svg" height="24" alt="Draw Parabola">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_absolute_value" title="Parabola"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.absoluteValue"
                [class.active]="isAbsoluteValueToolOn"
                (mousedown)="absoluteValue()">
          <img class="no-drag" src="assets/img/whiteboard/absolute-value.svg" height="24" alt="Draw Absolute Value">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_square_root" title="Square Root"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.squareRoot"
                [class.active]="isSquareRootToolOn"
                (mousedown)="squareRoot()">
          <img class="no-drag" src="assets/img/whiteboard/square-root.svg" height="24" alt="Draw Square Root">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_sin" title="Sin"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.sin"
                [class.active]="isSinToolOn"
                (mousedown)="sin()">
          <img class="no-drag" src="assets/img/whiteboard/sin.svg" height="24" alt="Draw Sin">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_sin" title="Cos"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.cos"
                [class.active]="isCosToolOn"
                (mousedown)="cos()">
          <img class="no-drag" src="assets/img/whiteboard/cos.svg" height="24" alt="Draw Cos">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_tan" title="Tan / Cot"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.tan"
                [class.active]="isTanToolOn"
                (mousedown)="tan()">
          <img class="no-drag" src="assets/img/whiteboard/tan.svg" height="24" alt="Draw Tan / Cot">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_segment" title="Segment"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.segment || wbContainer.drawers.segment.endPointType === PointType.ARROW"
                [class.active]="isSegmentToolOn"
                (mousedown)="segment()">
          <img class="no-drag" src="assets/img/whiteboard/segment.svg" height="24" alt="Draw Segment">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_ray" title="Ray"
                [class.d-none]="activeDrawer.shape !== wbContainer.drawers.segment || wbContainer.drawers.segment.endPointType !== PointType.ARROW"
                [class.active]="isRayToolOn"
                (mousedown)="ray()">
          <img class="no-drag" src="assets/img/whiteboard/ray.svg" height="24" alt="Draw Ray">
        </button>
        <button ngbDropdownToggle type="button" id="wb_btn_shapes_dd" class="btn whiteboard-btn dropdown-toggle-arrow-btn freeformButton px-1 mr-0">
          <span class="caret"></span>
        </button>
        <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu" style="min-width: unset">
          <div ngbDropdown class="btn-group select-shape w-100">
            <button ngbDropdownToggle type="button" class="dropdown-toggle-arrow-btn btn d-flex align-items-center px-2">
              <img src="assets/img/whiteboard/2d-shapes.svg" height="18" class="no-drag mr-2" alt=""> 2D Shapes
            </button>
            <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu">
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="circle()" title="Circle">
                <img src="assets/img/whiteboard/draw-circle.svg" height="18" class="no-drag mr-2" alt=""> Circle
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="ellipse()" title="Ellipse">
                <img src="assets/img/whiteboard/draw-ellipse.svg" height="18" class="no-drag mr-2" alt=""> Ellipse
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="rectangle()" title="Rectangle">
                <img src="assets/img/whiteboard/draw-rectangle.svg" height="18" class="no-drag mr-2" alt=""> Rectangle
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (click)="parallelogram()" title="Parallelogram">
                <img src="assets/img/whiteboard/draw-parallelogram.svg" height="18" class="no-drag mr-2" alt=""> Parallelogram
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (click)="isoscelesTrapezoid()" title="Isosceles Trapezoid">
                <img src="assets/img/whiteboard/draw-isosceles-trapezoid.svg" height="18" class="no-drag mr-2" alt=""> Isosceles Trapezoid
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="triangle()" title="Isosceles triangle">
                <img src="assets/img/whiteboard/draw-triangle.svg" height="18" class="no-drag mr-2" alt=""> Triangle
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="rightTriangle()" title="Right Triangle">
                <img src="assets/img/whiteboard/draw-right-triangle.svg" height="18" class="no-drag mr-2" alt=""> Right Triangle
              </button>
            </div>
          </div>
          <div ngbDropdown class="btn-group select-shape w-100">
            <button ngbDropdownToggle type="button" class="dropdown-toggle-arrow-btn btn d-flex align-items-center px-2">
              <img src="assets/img/whiteboard/3d-shapes.svg" width="18" class="no-drag mr-2" alt=""> 3D Shapes
            </button>
            <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu">
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="cube()" title="Cube">
                <img src="assets/img/whiteboard/draw-cube.svg" height="18" class="no-drag mr-2" alt=""> Cube
              </button>
              <div class="d-flex dropdown-item-with-input">
                <button class="dropdown-item d-flex align-items-center px-2 btn" (mousedown)="pyramid()" title="Pyramid">
                  <img src="assets/img/whiteboard/draw-pyramid.svg" height="18" class="no-drag mr-2" alt=""> Pyramid
                </button>
                <input [(ngModel)]="selectedPyramidVertices"
                       [min]="pyramidVerticesList[0]" [max]="pyramidVerticesList[pyramidVerticesList.length -1]"
                       class="form-control whiteboard-btn px-1"
                       title="Number of base edges"
                       style="width: 60px; height: 25px; margin-top: 2px"
                       type="number"/>
              </div>
              <div class="d-flex dropdown-item-with-input">
                <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="prism()" title="Right Prism">
                  <img src="assets/img/whiteboard/draw-prism.svg" height="18" class="no-drag mr-2" alt=""> Right Prism
                </button>
                <input [(ngModel)]="selectedPrismVertices"
                       [min]="prismVerticesList[0]" [max]="prismVerticesList[prismVerticesList.length -1]"
                       class="form-control whiteboard-btn px-1"
                       title="Number of base edges"
                       style="width: 60px; height: 25px; margin-top: 2px"
                       type="number"/>
              </div>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="cylinder()" title="Cylinder">
                <img src="assets/img/whiteboard/draw-cylinder.svg" height="18" class="no-drag mr-2" alt=""> Cylinder
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="cone()" title="Cone">
                <img src="assets/img/whiteboard/draw-cone.svg" height="18" class="no-drag mr-2" alt=""> Cone
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="sphere()" title="Sphere">
                <img src="assets/img/whiteboard/draw-sphere.svg" height="18" class="no-drag mr-2" alt=""> Sphere
              </button>
            </div>
          </div>
          <div ngbDropdown class="btn-group select-shape w-100">
            <button ngbDropdownToggle type="button" class="dropdown-toggle-arrow-btn btn d-flex align-items-center px-2">
              <img src="assets/img/whiteboard/graphs.svg" width="18" class="no-drag mr-2" alt=""> Graphs
            </button>
            <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu">
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="parabola()" title="Parabola">
                <img src="assets/img/whiteboard/parabola.svg" height="18" class="no-drag mr-2" alt=""> Parabola
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="absoluteValue()" title="Absolute Value">
                <img src="assets/img/whiteboard/absolute-value.svg" height="18" class="no-drag mr-2" alt=""> Absolute Value
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="squareRoot()" title="Square Root">
                <img src="assets/img/whiteboard/square-root.svg" height="18" class="no-drag mr-2" alt=""> Square Root
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="sin()" title="Sin">
                <img src="assets/img/whiteboard/sin.svg" height="18" class="no-drag mr-2" alt=""> Sin
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="cos()" title="Cos">
                <img src="assets/img/whiteboard/cos.svg" height="18" class="no-drag mr-2" alt=""> Cos
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="tan()" title="Tan / Cot">
                <img src="assets/img/whiteboard/tan.svg" height="18" class="no-drag mr-2" alt=""> Tan / Cot
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="segment()" title="Segment">
                <img src="assets/img/whiteboard/segment.svg" height="18" class="no-drag mr-2" alt=""> Segment
              </button>
              <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="ray()" title="Ray">
                <img src="assets/img/whiteboard/ray.svg" height="18" class="no-drag mr-2" alt=""> Ray
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="separator mx-1"></div>

      <div ngbDropdown autoClose="{{'outside'}}" class="select-shape-colors">
        <button ngbDropdownToggle
                type="button" id="wb_btn_text_style" class="btn whiteboard-btn p-0 without-dropdown-arrow transparent-bg font-btn"
                title="Text Properties"
                [class.background-none]="isTransparent(wbStyle.backgroundColor)"
                [style]="{'background': wbStyle.backgroundColor, 'color': wbStyle.fontColor}">Aa</button>
        <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu dropdown-content">
          <div class="font-size-12 mb-1">Font</div>
          <div class="font-size-grid mb-3">
            <div class="btn font-size-item"
                 *ngFor="let fontSize of fontSizeList"
                 [class.active]="wbStyle.fontSize === mkStr(fontSize)"
                 [style]="{'font-size': mkPx(fontSize), 'line-height': fontSize === 12 ? '24px': '22px'}"
                 (mousedown)="setFontSize(fontSize)">A</div>
            <div class="dropdown">
              <button type="button" class="btn font-size-item p-0 without-dropdown-arrow"
                      style="background: #e7eaef; border: 1px solid #cecece;"
                      (click)="toggleFontSizeDropdown($event)">
                <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
              </button>
              <div id="font-size-menu" class="dropdown-menu shadow cs-dropdown-menu"
                   [class.show]="isDialogOpen.fontSizeMore" style="min-width: 32px">
                <button class="dropdown-item btn d-flex align-items-center px-2"
                        *ngFor="let fontSizeMore of fontSizeMoreList"
                        [class.active]="wbStyle.fontSize === mkStr(fontSizeMore)"
                        (mousedown)="setCustomFontSize(fontSizeMore, $event)" >
                  {{fontSizeMore}}
                </button>
              </div>
            </div>
          </div>
          <div class="colors-grid">
            <div class="btn color-item transparent"
                 [class.active]="isTransparent(wbStyle.fontColor)"
                 (mousedown)="setFontColor('transparent'); setColorPickerValue('cpFont', '#00000000')"></div>
            <div class="btn color-item" *ngFor="let color of colorsList"
                 [style]="{'background':color, 'border': color === '#ffffff' ? '1px solid #cecece' : 'none'}"
                 [class.active]="areSameColors(wbStyle.fontColor, color)"
                 (mousedown)="setColorPickerValue('cpFont', color)"></div>
            <!--suppress JSUnusedGlobalSymbols -->
            <app-custom-color-picker #colorPicker
                                     [id]="'cpFont'"
                                     (visibilityChange)="colorPickerVisibilityChange($event)"
                                     (colorChange)="setFontColor($event)">
            </app-custom-color-picker>
          </div>
          <hr>

          <div class="font-size-12 mb-1">Background</div>

          <div class="colors-grid">
            <div class="btn color-item transparent"
                 [class.active]="isTransparent(wbStyle.backgroundColor)"
                 (mousedown)="setFontBgColor('transparent'); setColorPickerValue('cpFontBg', '#00000000')"></div>
            <div class="btn color-item" *ngFor="let color of colorsList"
                 [class.active]="areSameColors(wbStyle.backgroundColor, color)"
                 [style]="{'background': color, 'border': color === '#ffffff' ? '1px solid #cecece' : 'none'}"
                 (mousedown)="setColorPickerValue('cpFontBg', color)"></div>
            <app-custom-color-picker #colorPicker
                                     [id]="'cpFontBg'"
                                     (visibilityChange)="colorPickerVisibilityChange($event)"
                                     (colorChange)="setFontBgColor($event)">
            </app-custom-color-picker>
          </div>
        </div>
      </div>

      <button class="btn whiteboard-btn m-0 p-0"
              [class.active]="isTextBoxToolOn"
              id="wb_btn_text" (mousedown)="textBox()" title="Text Box">
        <img class="no-drag" src="assets/img/whiteboard/draw-textBox.svg" height="16" alt="">
      </button>
      <div class="separator mx-1"></div>

      <button class="btn whiteboard-btn p-0 mr-1 shapeButton"
              [class.active]="isTableToolOn"
              id="wb_btn_table" title="Table" (mousedown)="table()">
        <img class="no-drag" src="assets/img/whiteboard/draw-table.svg" height="20" alt="">
      </button>

      <div ngbDropdown class="btn-group">
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_coordinate_plane" title="Coordinate Plane"
                [class.d-none]="activeDrawer.cartesian !== wbContainer.drawers.coordinatePlane2"
                [class.active]="isCoordinatePlaneToolOn"
                (mousedown)="coordinatePlane2()">
          <img class="no-drag" src="assets/img/whiteboard/coordinate-plane.svg" height="24" alt="Draw Coordinate Plane">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 mr-0" id="wb_btn_number_line" title="Number Line"
                [class.d-none]="activeDrawer.cartesian !== wbContainer.drawers.numberLine2"
                [class.active]="isNumberLineToolOn"
                (mousedown)="numberLine2()">
          <img class="no-drag" src="assets/img/whiteboard/number-line.svg" height="24" alt="Draw Number Line">
        </button>
        <button type="button" class="btn whiteboard-btn p-0 shapeButton mr-0" id="wb_btn_unit_circle_chart" title="Unit Circle Chart"
                [class.d-none]="activeDrawer.cartesian !== wbContainer.drawers.image"
                [class.active]="isUnitCircleChartToolOn"
                (mousedown)="unitCircleChart()">
          <img class="no-drag" src="assets/img/whiteboard/draw-unit-circle-chart.svg" height="18" alt="Draw Circle Chart">
        </button>

        <button ngbDropdownToggle type="button" id="wb_btn_coordinate_plane_dd" class="btn whiteboard-btn dropdown-toggle-arrow-btn px-1">
          <span class="caret"></span>
        </button>
        <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu">
          <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="coordinatePlane2()" title="Coordinate Plane">
            <img src="assets/img/whiteboard/coordinate-plane.svg" height="24" class="no-drag mr-2" alt=""> Coordinate Plane
          </button>
          <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="numberLine2()" title="Number Line">
            <img src="assets/img/whiteboard/number-line.svg" height="24" class="no-drag mr-2" alt=""> Number Line
          </button>
          <button class="dropdown-item btn d-flex align-items-center px-2" (mousedown)="unitCircleChart()" title="Unit Circle Chart">
            <img src="assets/img/whiteboard/draw-unit-circle-chart.svg" height="24" class="no-drag mr-2" alt=""> Unit Circle Chart
          </button>
        </div>
      </div>

      <div class="separator mx-1"></div>

      <button class="btn whiteboard-btn p-0"
              [class.active]="isGridOn"
              id="wb_btn_grid" (mousedown)="grid()" title="Grid">
        <img class="no-drag" src="assets/img/whiteboard/grid.svg" height="16" alt="">
      </button>

      <div ngbDropdown>
        <button ngbDropdownToggle type="button" id="wb_btn_grid_size_dd" class="btn whiteboard-btn dropdown-toggle d-flex align-items-center" title="Grid size">
          {{wbContainer.grid.getSnapSide()}}
        </button>
        <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu" style="min-width: 46px">
          <button class="dropdown-item btn d-flex align-items-center px-2"
                  *ngFor="let gridSide of gridSideList"
                  [class.active]="wbContainer.grid.getSnapSide() === gridSide"
                  (mousedown)="wbContainer.grid.setSnapSide(gridSide)">
            {{gridSide}}
          </button>
        </div>
      </div>

      <button class="btn whiteboard-btn mr-0" id="wb_btn_snap" title="Snap to Grid"
              [class.active]="isSnapOn"
              (mousedown)="snap()">Snap</button>

      <div class="separator mx-1"></div>

      <div ngbDropdown autoClose="{{'outside'}}" class="mr-auto">
        <button ngbDropdownToggle type="button" id="wb_btn_more_menu" class="btn whiteboard-btn p-0 without-dropdown-arrow mr-0">
          <i class="fas fa-ellipsis-h" aria-hidden="true"></i></button>
        <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu dropdown-content">
          <div class="form-check mb-2">
            <input class="form-check-input" type="checkbox" id="wb_check_streaming"
                   [disabled]="!isDrawing"
                   (click)="toggleStreaming()"
                   [(ngModel)]="whiteboard.streaming">
            <label class="form-check-label" for="wb_check_streaming">
              Streaming
            </label>
            <br/>
            <input class="form-check-input" type="checkbox" id="wb_check_smooth"
                   [disabled]="!isDrawing"
                   (click)="toggleSmooth()"
                   [(ngModel)]="whiteboard.smooth">
            <label class="form-check-label" for="wb_check_smooth">
              Smooth
            </label>
            <br/>
          </div>

          <div class="d-flex mb-2">
            <button class="btn whiteboard-btn w-100 px-2" id="wb_btn_group" title="Group two or more elements"
                    [disabled]="!isGroupApplicable"
                    (mousedown)="group()">Group</button>
            <button class="btn whiteboard-btn w-100 px-2" id="wb_btn_ungroup" title="Ungroup a group"
                    [disabled]="!isUngroupApplicable"
                    (mousedown)="ungroup()">Ungroup</button>
          </div>

          <div class="grid-4 mb-2">
            <button id="wb_btn_copy" class="btn whiteboard-btn p-0" title="Copy (Ctrl + C)"
                    [disabled]="isEditNodeToolOn || isEditTableToolOn"
                    (mousedown)="copyFocused()">
              <img class="no-drag" src="assets/img/whiteboard/copy.svg" height="17" alt="">
            </button>
            <button id="wb_btn_cut" class="btn whiteboard-btn p-0" title="Cut (Ctrl + X)"
                    [disabled]="isEditNodeToolOn || isEditTableToolOn"
                    (mousedown)="cutFocused()">
              <img class="no-drag" src="assets/img/whiteboard/cut.svg" height="17" alt="">
            </button>
            <button id="wb_btn_paste" class="btn whiteboard-btn p-0" title="Paste (Ctrl + V)"
                    [disabled]="isEditNodeToolOn || isEditTableToolOn"
                    (mousedown)="paste()">
              <img class="no-drag" src="assets/img/whiteboard/paste.svg" height="17" alt="">
            </button>
            <button id="wb_btn_select_all" class="btn whiteboard-btn p-0" title="Select all (Ctrl + A)"
                    [disabled]="isEditNodeToolOn || isEditTableToolOn"
                    (mousedown)="selectAll()">
              <img class="no-drag" src="assets/img/whiteboard/select-all.svg" height="17" alt="">
            </button>
            <button id="wb_btn_delete" class="btn whiteboard-btn p-0" title="Delete Selected (Del)"
                    [disabled]="isEditNodeToolOn || isEditTableToolOn"
                    (mousedown)="deleteSelected()">
              <img class="no-drag" src="assets/img/whiteboard/delete.svg" height="17" alt="">
            </button>
            <button class="btn whiteboard-btn p-0" title="To Top (Shift + PageUp)"
                    (mousedown)="orderTop()">
              <img class="no-drag" src="assets/img/whiteboard/to-top.svg" height="17" alt="">
            </button>
            <button class="btn whiteboard-btn p-0" title="To Bottom (Shift + PageDown)"
                    (mousedown)="orderBottom()">
              <img class="no-drag" src="assets/img/whiteboard/to-back.svg" height="17" alt="">
            </button>
            <button class="btn whiteboard-btn p-0" title="Recenter Reference Point"
                    (mousedown)="recenterRefPoint()">
              <img class="no-drag" src="assets/img/whiteboard/recenter-reference-point.svg" height="17" alt="">
            </button>
          </div>
          <div class="d-flex">
            <button class="btn whiteboard-btn w-100 px-2" title="Share"
                    [disabled]="whiteboard.sharedUsers?.size === 0 || (assignment.isLoaded && !classroom.showPrivateWhiteboard)"
                    (mousedown)="share()">Share</button>
            <button class="btn whiteboard-btn w-100 px-2" title="unshare"
                    [disabled]="!whiteboard.sharedUsers"
                    (mousedown)="unshare()">Unshare</button>
          </div>
        </div>
      </div>
    </div>

<!--    <button class="btn whiteboard-btn p-0" (mousedown)="shareScreen()">Share</button>-->

    <div class="d-flex ml-auto">
      <div class="d-flex" *ngIf="assignment.isLoaded && !classroom.showPrivateWhiteboard">
        <div class="d-flex h-100">
          <button type="button" id="wb_btn_unload_assignment" class="btn whiteboard-btn p-0 assignment-unload-icon"
                  title="Unload the assignment"
                  (mousedown)="sendUnloadAssignment()">
          </button>
        </div>
        <div class="wb-switcher d-flex">
          <button type="button" id="wb_toggle_switch_wb" class="btn whiteboard-btn switcher-wb-a-btn mr-0" style="height: 26px"
                  title="Whiteboard"
                  (mousedown)="localUser.currentSelectedTab !== ViewportTab.WHITEBOARD && switchViewPortTab(ViewportTab.WHITEBOARD)"
                  [class.active]="localUser.currentSelectedTab === ViewportTab.WHITEBOARD">WB
          </button>

          <button type="button" id="wb_toggle_switch_a" class="btn whiteboard-btn switcher-wb-a-btn ml-0" style="height: 26px"
                  title="Assignment"
                  (mousedown)="localUser.currentSelectedTab !== ViewportTab.ASSIGNMENT && switchViewPortTab(ViewportTab.ASSIGNMENT)"
                  [class.active]="localUser.currentSelectedTab === ViewportTab.ASSIGNMENT">A
          </button>

          <button type="button" id="wb_toggle_switch_t" class="btn whiteboard-btn switcher-wb-a-btn ml-0" style="height: 26px"
                  title="Report"
                  (mousedown)="localUser.currentSelectedTab !== ViewportTab.REPORT && switchViewPortTab(ViewportTab.REPORT)"
                  [class.active]="localUser.currentSelectedTab === ViewportTab.REPORT">R
          </button>
        </div>
        <button type="button" id="wb_btn_allow_switch" class="btn whiteboard-btn p-0 allow-switcher-icon" title="Allow switching"
                *ngIf="localUser.accessType !== AccessType.OBSERVER"
                [class.active]="(assignment.allowedSwitchingUsers?.size === 0 || assignment.allowedSwitchingUsers?.has(localUser.id))"
                (mousedown)="toggleWBTabSwitcherForAll()"
                [disabled]="isInRestrictedMode">
          <i class="far fa-exchange"></i>
        </button>
      </div>

      <button type="button" id="wb_btn_extend_whiteboard"
              *ngIf="localUser.accessType !== AccessType.OBSERVER"
              class="btn whiteboard-btn p-0 shapeButton extend-button"
              title="Extend Whiteboard. The percentage of whiteboard used"
              (mousedown)="extendWhiteboard()"
              [disabled]="(localUser.currentSelectedTab !== ViewportTab.WHITEBOARD || isExtendNotApplicable()) && !classroom.showPrivateWhiteboard || isInRestrictedMode">
        <i class="fas fa-arrow-alt-from-top"></i>
        {{ whiteboardHeightPercent }}%
      </button>
      <button type="button"
              class="btn whiteboard-btn p-0 shapeButton"
              title="Refresh Whiteboard"
              (mousedown)="refreshWhiteboard()"
              [disabled]="localUser.currentSelectedTab !== ViewportTab.WHITEBOARD && !classroom.showPrivateWhiteboard || isInRestrictedMode">
        <i class="fas fa-sync"></i>
      </button>
      <div ngbDropdown class="wb-actions" *ngIf="localUser.accessType !== AccessType.OBSERVER">
        <button ngbDropdownToggle type="button" id="wb_btn_actions_dd" class="btn whiteboard-btn dropdown-toggle mr-0"
                [disabled]="localUser.currentSelectedTab !== ViewportTab.WHITEBOARD&& !classroom.showPrivateWhiteboard">
          Actions
        </button>
        <div ngbDropdownMenu class="dropdown-menu shadow cs-dropdown-menu dropdown-menu-right">
          <button type="button" class="dropdown-item btn d-flex align-items-center px-2" title="Open a curriculum chapter."
                  [disabled]="isInRestrictedMode"
                  (mousedown)="openCurriculum()">
            <i class="fas fa-file-alt mr-1"></i> Insert Curriculum Problem
          </button>
          <div class="dropdown-divider"></div>
          <button type="button" class="dropdown-item btn d-flex align-items-center px-2" title="Reset Whiteboard"
                  [disabled]="isInRestrictedMode"
                  (mousedown)="openResetWhiteboardDialog()">
            <i class="fas fa-undo-alt mr-1"></i> Reset Whiteboard
          </button>

          <ng-container *ngIf="localUser.accessType === AccessType.SUPPORT">
            <div class="dropdown-divider"></div>
            <button *ngIf="isInRestrictedMode" type="button" class="dropdown-item btn d-flex align-items-center px-2" title="Disable restricted mode"
                    (mousedown)="toggleRestrictedMode()">
              <i class="fas fa-solid fa-unlock mr-1"></i> Disable restricted mode
            </button>
            <button *ngIf="!isInRestrictedMode" type="button" class="dropdown-item btn d-flex align-items-center px-2" title="Enable restricted mode"
                    (mousedown)="toggleRestrictedMode()">
              <i class="fas fa-solid fa-lock mr-1"></i> Enable restricted mode
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
